import { useGetMyTrainingModules } from './useGetMyTrainingModules'
import { useGetTrainingModuleReview } from './useGetTrainingModuleReview'
import { useGetTrainingModuleReviewDetails } from './useGetTrainingModuleReviewDetails'
import { useGetMineTrainingStats, useGetTrainingStats } from './useGetTrainingStats'
import { useAttemptsStats, useModulesList } from './useTrainer'
import {
  useCreate,
  useDelete,
  useDuplicate,
  useEdit,
  useGetByProgram,
  useGetListByProgram,
  usePostTrainingModuleResolution,
  usePublish,
} from './useTrainingModule'

const trainer = {
  modulesList: useModulesList,
  attemptsStats: useAttemptsStats,
}

export const trainingModules = {
  getByProgram: useGetListByProgram,
  getModuleByProgram: useGetByProgram,
  delete: useDelete,
  edit: useEdit,
  publish: usePublish,
  create: useCreate,
  duplicate: useDuplicate,
  /**
   * Related to the actual usage of training modules by mission specialist
   */
  trainer,
  postResolution: usePostTrainingModuleResolution,
  v3: {
    getMyModules: useGetMyTrainingModules,
    getMineTrainingStats: useGetMineTrainingStats,
    getTrainingStats: useGetTrainingStats,
    getTrainingModuleReview: useGetTrainingModuleReview,
    getTrainingModuleReviewDetails: useGetTrainingModuleReviewDetails,
  },
}
